import React from "react";

import abhiLogo from "../../assets/images/assets/abhi-logo.jpg";

import "./style.css";

export default function ConsentScreen({setGameConsent}) {
  return (
    <>
      <div className="container">
        <img className="abhi-logo" src={abhiLogo} alt="logo-abhi" />

        <p>
        Didn't get approved for your loan? <br/>ABHI is giving you a second chance! Play this quick 3-minute psychometric game to show your true credit potential — no paperwork, just your personality. Take the game now
        </p>

        <button
          className="continue_button"
          onClick={() => {
            setGameConsent(true);
          }}
        >
          CONTINUE TO GAME
        </button>
      </div>
    </>
  );
}
